import Slider from '../services/sliderService';

export default function reviewSlider() {
    const elements = document.querySelectorAll('.js-review-slider');

    function createReviewSlider(element, wrapper) {
        const options = {
            slideVisibleClass: 'review-slider__slider-item--visible',
            breakpoints: {
                1044: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
            },
            wrapperElement: wrapper,
        };

        new Slider(element, options); // eslint-disable-line no-new
    }

    elements.forEach((element) => {
        const wrapper = element.closest('.review-slider');

        createReviewSlider(element, wrapper);
    });
}
